import styles from './Logo.module.css';

export const Logo = () => {
  return (
    <div className={styles.logoContainer}>
      <img src='/logo.svg' alt='AB Bull Roster Logo' className={styles.logo} />
    </div>
  );
};
